module.exports = __webpack_public_path__ + "assets/img/sailing-version-advantage-banner.82c551f3.png";